import React from 'react';
import { RouteObject } from 'react-router-dom';
import { PermissionKey } from '../../utils/apollo/graphqlSchema';
import { appRoutes } from '../../path';
import ProtectedRoute from '../../components/ProtectedRoute';
import RedirectRoute from '../RedirectRoute';
import DashboardLegacyRedirects from './DashboardLegacyRedirects';
import DashboardIndexPage from './DashboardIndexPage';
import DashboardInstancePage from './DashboardInstancePage';
import DashboardHistoryInstancePage from './DashboardHistoryInstancePage';
import SidebarLayout from '../../Layout/SidebarLayout';
import DashboardNav from './DashboardNav';

const dashboardRoutes: RouteObject[] = [
  // Legacy routes
  {
    path: '/dashboard',
    element: (
      <RedirectRoute from="/dashboard" to={appRoutes.dashboard.routePrefix} />
    ),
  },
  {
    path: '/dashboard/:dashboardTemplateId',
    element: <DashboardLegacyRedirects />,
  },
  {
    path: '/dashboard/:dashboardTemplateId/instance/:instanceId',
    element: <DashboardLegacyRedirects />,
  },
  {
    // All Dashboard routes are protected and user should have DashboardRead permission
    element: (
      <ProtectedRoute allRequiredPermissionKeys={[PermissionKey.DashboardRead]}>
        <SidebarLayout>
          <DashboardNav />
        </SidebarLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        path: appRoutes.dashboard.routePrefix,
        element: <DashboardIndexPage />,
      },
      {
        path: appRoutes.dashboard.routePrefix + '/:dashboardBaseId',
        element: <DashboardInstancePage />,
      },
      {
        path: appRoutes.dashboard.routePrefix + '/:dashboardBaseId/:instanceId',
        element: <DashboardHistoryInstancePage />,
      },
    ],
  },
];

export default dashboardRoutes;
